import React, { Component } from 'react';
import List, { ListItem } from 'material-ui/List';
import Typography from 'material-ui/Typography';
import { NavLink, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';

import Paper from 'material-ui/Paper';
import { getFilteredDataPerPage } from '../reports.selectors';
import * as ReportsActions from '../reports.actions';
import * as InspectionActions from '../../inspection/inspection.actions';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { statusToString } from '../../../utils/user-utils';
import { getCurrentUserRole, getCurrentUserCompany } from '../../user/user.selectors';
import { UserRoles } from '../../user/user.constants';
import Loading from '../../core/components/Loading';

const styles = theme => ({
  root: {
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing.unit * 2,
  },
  empty: {
    'font-style': 'italic',
  },
  id: {
    'font-weight': 'bold',
    'font-size': '16px',
    color: 'rgba(0,0,0,0.87)',
    'line-height': '24px',
  },
  text: {
    color: theme.palette.common.accentOrange,
  },
  content: {
    margin: '0 auto',
    boxSizing: 'border-box',
  },
  card: {
    padding: theme.spacing.unit * 2,
  },
  headline: {
    color: theme.palette.common.white,
    flex: 1,
    '@media (max-width:599px)': {
      paddingTop: 0,
      marginTop: 0,
      marginBottom: 0,
    },
  },
  topCaption: {
    marginBottom: '0.5rem',
  },
  wrapper: {
    display: 'flex',
    alignItems: 'center',
    '@media (max-width:599px)': {
      display: 'block',
      textAlign: 'center',
      position: 'relative',
    },
  },
  loader: {
    position: 'absolute',
    top: '0rem',
    right: '0rem',
  },
  button: {
    '@media (max-width:599px)': {
      marginBottom: '20px',
    },
  },
  listItem: {
    display: 'block',
    paddingLeft: 0,
    paddingRight: 0,
  },
});

class MobileReportsList extends Component {
  componentDidMount = () => {
    const {
      readInspections,
      readInspectionSchemas,
      readInspectionTypes,
      readFormDatas,
      setReportsPerPage,
      setReportsSort,
      company
    } = this.props;
    readInspections();
    readInspectionTypes(company);
    readInspectionSchemas(company);
    readFormDatas();
    setReportsSort('identifier', 'desc');
    //Force filter on mobile
    //setReportsFilter({ value: 'completed', reverse: true }, 'status');
    //Aritifical limit
    setReportsPerPage(9999);
  };

  handleClick = (id, status) => () => {
    if (status === 'completed') {
      this.props.history.push(`inspection/view/${id}/raportti`)
    } else {
      this.props.history.push(`/inspection/edit/${id}/`);
    }
  };

   renderReports() {
    const { reports, classes, isFetching } = this.props;
    if (isFetching) {
      return (
        <Typography type="caption" className={classes.empty} gutterBottom>
          Ladataan raportteja...
          <div className={classes.loader}>
            <Loading />
          </div>
        </Typography>
      );
    } else {
      if (!reports || reports.length === 0) {
        return (
          <Typography type="caption" className={classes.empty} gutterBottom>
            Ei keskeneräisiä raportteja.
          </Typography>
        );
      } else {
        return reports.map((report, index) => {
          return (
            <ListItem key={index} button className={classes.listItem} onClick={this.handleClick(report._id, report.status)}>
              <Typography className={classes.id}>{report.identifier}</Typography>
              <Typography>{report.section}</Typography>
              <Typography>{report.client}</Typography>
              <Typography className={classes.text}>{statusToString(report.status)}</Typography>
            </ListItem>
          );
        });
      }
    }
  }

  render() {
    const { role, classes } = this.props;
    const isGuest = role === UserRoles.GUEST;
    return (
      <div className={classes.root}>
        <div className={classes.content}>
          <div className={classes.wrapper}>
            <Typography color="accent" type="headline" gutterBottom className={classes.headline}>
              Digitaaliset tarkastusraportit
            </Typography>
            {!isGuest && (
              <NavLink to="/inspection/new">
                <Button raised color="accent" className={classes.button}>
                  Uusi raportti <i className="material-icons">chevron_right</i>
                </Button>
              </NavLink>
            )}
          </div>
          <Paper className={classes.card}>
            <Typography type="caption" className={classes.topCaption}>
              Keskeneräiset raporttini
            </Typography>
            <List>{this.renderReports()}</List>
          </Paper>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const reports = getFilteredDataPerPage(state);
  const role = getCurrentUserRole(state);
  const company = getCurrentUserCompany(state);
  const isFetching = state.entities.inspection.isFetching;

  return {
    reports,
    role,
    company,
    isFetching,
  };
};

export default withRouter(
  connect(mapStateToProps, Object.assign({}, ReportsActions, InspectionActions))(withStyles(styles)(MobileReportsList))
);



// WEBPACK FOOTER //
// ./src/modules/reports/components/MobileReportsList.js